// Generated by CoffeeScript 2.7.0
var RangePicker;

import DateTimePicker from 'trunks/vue/admin/components/libs/date_time_picker.js';

export default RangePicker = Vue.extend({
  components: {
    'datetime-picker': DateTimePicker
  },
  props: {
    initValue: {
      type: Object
    },
    viewMode: {
      type: String,
      default: 'date'
    },
    limitStart: Date,
    limitEnd: Date,
    modeChangeable: {
      type: Boolean,
      default: true
    },
    rangable: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      value: {
        static: {
          start: null,
          end: null
        },
        dynamic: {
          start: null,
          end: null
        }
      },
      viewType: this.viewMode,
      dynamic: false,
      rangePosition: 'start'
    };
  },
  template: `<div class="rangepicker">
  <div class="popover-select-header">
    <div class="filter-header justify-between">
      <div class="left justify-box">
        <div class="filter-header-label"
             :class="{'active' : rangePosition == 'start'}"
             @click="selectRangePosition('start')">
          <span v-if="modeChangeable || viewType == 'date'">{{ filterDateText('start') }}</span>
          <span v-if="modeChangeable || viewType == 'time'">{{ filterTimeText('start') }}</span>
        </div>
        <span class="divider">~</span>
        <div class="filter-header-label"
             :class="{'active' : rangePosition == 'end'}"
             @click="selectRangePosition('end')">
          <span v-if="modeChangeable || viewType == 'date'">{{ filterDateText('end') }}</span>
          <span v-if="modeChangeable || viewType == 'time'">{{ filterTimeText('end') }}</span>
        </div>
      </div>
      <i class="slp-minus-circle" @click="destroyValueIfNeed"></i>
    </div>
  </div>
  <datetime-picker ref='picker'
                   :initValue='defaultValue'
                   :viewMode='viewType'
                   :limitEnd='limitEnd'
                   :limitStart='limitStart'
                   :isDynamic='dynamic'
                   :showDateValueTip='false'
                   @valueChanged='updateValue'
                   @viewModeChanged='updateViewMode' />
  <div class="popover-select-footer">
    <div class="btn text-btn" @click='selectDynamicType(false)' v-if='showDynamicTypeBtn(false)'>固定</div>
    <div class="btn text-btn" @click='selectDynamicType(true)' v-if='showDynamicTypeBtn(true)'>动态</div>
    <div class="btn text-btn" @click='switchViewMode' v-if='modeChangeable && viewType !== "time"'>选时间</div>
    <div class="btn text-btn" @click='ensureClicked'>确认</div>
  </div>
</div>`,
  computed: {
    startDefaultTime: function() {
      return new Date().midnight();
    },
    endDefaultTime: function() {
      return new Date().endOfDay();
    },
    currentRangeValue: function() {
      var _dynamic_type;
      _dynamic_type = this.dynamic ? 'dynamic' : 'static';
      return this.value[_dynamic_type];
    },
    defaultValue: function() {
      var _result;
      if (this.dynamic) {
        return this.currentRangeValue[this.rangePosition];
      } else {
        _result = this.currentRangeValue[this.rangePosition];
        if (_result) {
          return _result;
        } else {
          if (this.rangePosition === 'start') {
            return this.startDefaultTime;
          } else {
            return this.endDefaultTime;
          }
        }
      }
    }
  },
  watch: {
    dynamic: function(newValue, oldValue) {
      var _old_dynamic;
      _old_dynamic = oldValue ? 'dynamic' : 'static';
      if (this.currentRangeValue[this.rangePosition]) {
        this.updateTimeIfNedd(this.value[_old_dynamic][this.rangePosition]);
      }
      this.setPickerValue();
      this.$refs.picker.setDynamic(newValue);
      return this.$emit('dynamicTypeChanged', newValue);
    }
  },
  methods: {
    showDynamicTypeBtn: function(boolean) {
      if (this.modeChangeable) {
        return this.dynamic !== boolean || this.viewType === 'time';
      } else {
        if (this.viewType === 'time') {
          return false;
        } else {
          return this.dynamic !== boolean;
        }
      }
    },
    selectDynamicType: function(boolean) {
      if (this.viewType === 'time') {
        this.switchViewMode();
      }
      return this.$nextTick(function() {
        return this.dynamic = boolean;
      });
    },
    setPickerValue: function() {
      var _result, _value, ref, ref1, str;
      _value = !this.dynamic ? (_result = this.currentRangeValue[this.rangePosition], _result ? _result : this.rangePosition === 'start' ? this.startDefaultTime : this.endDefaultTime) : this.viewType === 'time' ? (str = ((ref = this.currentRangeValue[this.rangePosition]) != null ? ref.split(' ')[1] : void 0) || '', Date.parseFromString(str)) : ((ref1 = this.currentRangeValue[this.rangePosition]) != null ? ref1.split(' ')[0] : void 0) || null;
      this.$refs.picker.setVmValue(_value);
      if (_value) {
        return this.$nextTick(function() {
          return this.$refs.picker.setValue(_value);
        });
      }
    },
    switchViewMode: function() {
      return this.$refs.picker.switchViewMode();
    },
    updateViewMode: function(viewMode) {
      this.viewType = viewMode;
      this.setDefaultTime();
      if (this.currentRangeValue[this.rangePosition]) {
        return this.setPickerValue();
      }
    },
    updateValue: function(newValue) {
      var _old_value, _result, _time;
      if (this.dynamic) {
        if (this.currentRangeValue[this.rangePosition]) {
          _result = this.currentRangeValue[this.rangePosition].split(' ');
          if (newValue instanceof Date) {
            _result[1] = newValue.strftime('hh:mm');
            return this.currentRangeValue[this.rangePosition] = _result[0] + ` ${_result[1]}`;
          } else {
            _time = _result[1] ? ` ${_result[1]}` : '';
            return this.currentRangeValue[this.rangePosition] = newValue + _time;
          }
        } else {
          return this.currentRangeValue[this.rangePosition] = newValue;
        }
      } else {
        if (newValue) {
          _old_value = this.currentRangeValue[this.rangePosition];
          if (_old_value) {
            return this.currentRangeValue[this.rangePosition] = newValue;
          } else {
            _result = this.rangePosition === 'start' ? newValue.midnight() : newValue.endOfDay();
            this.currentRangeValue[this.rangePosition] = _result;
            return this.setPickerValue();
          }
        } else {
          if (this.rangePosition === 'start') {
            return this.startDefaultTime;
          } else {
            return this.endDefaultTime;
          }
        }
      }
    },
    filterDateText: function(position) {
      var _default_text, _position_text, _result, ref;
      _result = this.currentRangeValue[position];
      _position_text = Skylark.Helpers.getZH_CN('rangePosition');
      _default_text = _position_text[position] + '时间';
      if (!_result) {
        return _default_text;
      }
      if (this.dynamic) {
        _result = (ref = this.currentRangeValue[position]) != null ? ref.split(' ')[0] : void 0;
        if (_result === 'null') {
          return _default_text;
        } else {
          return Skylark.Helpers.Utilities.stringifyFilter(_result);
        }
      } else {
        return _result.strftime('YYYY年MM月DD日');
      }
    },
    filterTimeText: function(position) {
      var _default_text, _position_text, ref, ref1, ref2;
      _position_text = Skylark.Helpers.getZH_CN('rangePosition');
      _default_text = _position_text[position] + '时间';
      if (this.modeChangeable) {
        if (this.dynamic) {
          return (ref = this.currentRangeValue[position]) != null ? ref.split(' ')[1] : void 0;
        } else {
          return (ref1 = this.currentRangeValue[position]) != null ? ref1.strftime('hh:mm') : void 0;
        }
      } else {
        return ((ref2 = this.currentRangeValue[position]) != null ? ref2.strftime('hh:mm') : void 0) || _default_text;
      }
    },
    selectRangePosition: function(position) {
      this.rangePosition = position;
      this.setDefaultTime();
      return this.setPickerValue();
    },
    setDefaultTime: function() {
      var ref;
      if (this.viewType === 'time' && this.dynamic) {
        if ((ref = this.currentRangeValue[this.rangePosition]) != null ? ref.split(' ')[1] : void 0) {
          return;
        }
        this.currentRangeValue['start'] += ' 00:00';
        return this.currentRangeValue['end'] += ' 23:59';
      }
    },
    updateTimeIfNedd: function(old_value) {
      var str;
      if (old_value instanceof Date) {
        return this.updateValue(old_value);
      } else {
        str = old_value != null ? old_value.split(' ')[1] : void 0;
        if (!str) {
          return;
        }
        return this.updateValue(Date.parseFromString(str));
      }
    },
    destroyValueIfNeed: function() {
      this.$refs.picker.reset();
      return this.$nextTick(function() {
        if (this.modeChangeable && this.viewType === 'time') {
          this.switchViewMode();
        }
        this.$refs.picker.setVmValue();
        return this.value = {
          static: {
            start: null,
            end: null
          },
          dynamic: {
            start: null,
            end: null
          }
        };
      });
    },
    ensureClicked: function() {
      var _result;
      _result = _.clone(this.currentRangeValue);
      return this.$emit('ensureClicked', _result, this.dynamic ? 'dynamic' : 'static');
    }
  }
});
